/**
 * Where players come from (owner, 2026-10-20): a link's ?ref= tag, else the referring site's host. Shared by the
 * front page (which passes it on to /play as ?from=), the app (which sends it with the first story) and the Worker.
 */

/** A source as kept: a lower-case tag or host name, at most 48 characters. */
export const SOURCE_RE = /^[a-z0-9][a-z0-9._-]{0,47}$/;

/** The visit's source, or null when it came straight in (or from Weftwake itself). Pure. */
export function sourceOf(url: string, referrer: string | null | undefined): string | null {
  const u = new URL(url);
  const ref = (u.searchParams.get("ref") ?? "").trim().toLowerCase();
  if (SOURCE_RE.test(ref)) return ref;
  if (!referrer) return null;
  try {
    const host = new URL(referrer).hostname.toLowerCase().replace(/^www\./, "");
    const own = u.hostname.toLowerCase().replace(/^www\./, "");
    return host && host !== own && SOURCE_RE.test(host) ? host : null;
  } catch { return null; }
}
